import { B2Tabs } from "@hdb/biome-2";
import { FC, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import TableComponent from "src/core/components/table/table.component";
import { useAppDispatch } from "src/store/hooks";
import { closeDetailsModal, closeToaster } from "src/store/slices/upload-progress.slice";
import AssetUploadModal from "../asset-upload-modal.component";
import "./upload-progress-toaster.component.scss";

const PAGE_SIZE = 5;
const NEW_TAB = "NewAssetCodes";
const DELETED_TAB = "DeletedAssetCodes";

const columns = [
  {
    title: "Asset Code",
    label: "assetCode",
  },
];

const emptyConfig = {
  title: "No Data Found",
  description: "",
};

const paginate = (array: any[], page: number) =>
  array.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

const AssetUploadDetailsModal: FC = () => {
  const dispatch = useAppDispatch();
  const { detailsModalOpen, insertedAssetCodes, deletedAssetCodes } =
    useSelector((state: any) => state.uploadProgress);

  const [activeTab, setActiveTab] = useState(NEW_TAB);
  const [newPage, setNewPage] = useState(1);
  const [deletedPage, setDeletedPage] = useState(1);

  const newRows = useMemo(
    () => (insertedAssetCodes ?? []).map((assetCode: string) => ({ assetCode })),
    [insertedAssetCodes],
  );
  const deletedRows = useMemo(
    () => (deletedAssetCodes ?? []).map((assetCode: string) => ({ assetCode })),
    [deletedAssetCodes],
  );

  useEffect(() => {
    if (!detailsModalOpen) {
      setActiveTab(NEW_TAB);
      setNewPage(1);
      setDeletedPage(1);
    }
  }, [detailsModalOpen]);

  if (!detailsModalOpen) return null;

  const noop = () => {};

  return (
    <AssetUploadModal
      showModal={detailsModalOpen}
      handleClose={() => {
        dispatch(closeDetailsModal());
        dispatch(closeToaster());
      }}
      subHeader="New and deleted assets from this upload"
      size="lg"
    >
      <div className="custom_tab_start" style={{ position: "relative" }}>
        <B2Tabs
          activeKey={activeTab}
          pills
          tabClassName={""}
          onSelect={(selectedId: any) => setActiveTab(selectedId)}
          tab={[
            {
              content: (
                <div>
                  <TableComponent
                    tableHeaders={columns}
                    emptyConfig={emptyConfig}
                    data={paginate(newRows, newPage)}
                    totalNumberOfRecords={newRows.length}
                    pageSize={PAGE_SIZE}
                    current={newPage}
                    onChangePage={setNewPage}
                    onChangeSort={noop}
                  />
                </div>
              ),
              id: NEW_TAB,
              title: `New Asset Codes (${newRows.length})`,
            },
            {
              content: (
                <div>
                  <TableComponent
                    tableHeaders={columns}
                    emptyConfig={emptyConfig}
                    data={paginate(deletedRows, deletedPage)}
                    totalNumberOfRecords={deletedRows.length}
                    pageSize={PAGE_SIZE}
                    current={deletedPage}
                    onChangePage={setDeletedPage}
                    onChangeSort={noop}
                  />
                </div>
              ),
              id: DELETED_TAB,
              title: `Deleted Asset Codes (${deletedRows.length})`,
            },
          ]}
        />
      </div>
    </AssetUploadModal>
  );
};

export default AssetUploadDetailsModal;
